import { createStore, type StoreApi } from "zustand/vanilla";

import { defaultFilterForm } from "./filters";
import type { GameState } from "./types";

export function initialState(): GameState {
  return {
    screen: "loading",
    toast: null,
    fatalMessage: null,
    busy: false,
    catalog: null,
    collections: null,
    filterForm: defaultFilterForm(),
    session: null,
    waiting: "peer",
    connection: null,
    peerOnline: false,
    deck: [],
    index: 0,
    likes: [],
    matchId: null,
    otherProgress: null,
  };
}

export function createGameStore(): StoreApi<GameState> {
  return createStore<GameState>(() => initialState());
}
